import { createStore } from 'vuex';
import { layout } from './layout';
import { permissions } from './permissions';
import { eNotify } from './eNotify';
import { mNotify } from './mNotify';
import { vipBirth } from './vipBirth';
import { policy } from './policy';
import { isDevMode, isProdMode } from '@/utils/is';

import createPersistedState from 'vuex-persistedstate';
import SecureLS from '@/plugins/secure-ls';

const ls = new SecureLS({
    isCompression: false,
    encodingType: 'aes',
});

const storage = !isProdMode() ? window.sessionStorage : {
    getItem: key => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: key => ls.remove(key),
};
export default createStore({
    state: {},
    mutations: {},
    actions: {
        removeSession() {
            isDevMode() ? ls.removeAll() : sessionStorage.clear();
        },
    },
    modules: {
        layout,
        permissions,
        policy,
        eNotify,
        mNotify,
        vipBirth,
    },
    plugins: [createPersistedState({
        key: 'info',
        storage,
    })],
});
